/*
 * Date: 2020-07-21 13:14:32
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-03 11:55:57
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
const FormWidgetLocationConfig = {
  // 类型
  componentType: 'FORM_WIDGET_LOCATION',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-location',
    text: '定位',
    optionTitle: true,
    description: '支持通过移动端定位获取当前地理位置'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormWidgetLocation',
      edit: 'FormWidgetLocation',
      read: 'FormWidgetLocation'
    },
    label: '定位',
    locationRange: '100',
    locationCenterList: [],
    showLocationCenter: false,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      }
    }
    // inTable: true
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'ADJUST_LOCATION',
    'LOCATION_CENTER',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW'
  ]
  // excludeEditorConfigInTable: ['WIDTH']
}

export default FormWidgetLocationConfig
